var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('applications-list',{attrs:{"columnDefs":_vm.columnDefs,"statusCount":_vm.statusCount,"positionCount":_vm.positionCount,"employmentStatusCount":_vm.employmentStatusCount,"applicationStatus":_vm.applicationStatus,"isApplicantView":_vm.isApplicantView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }